import React, { useEffect, useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Axios from "axios";
import DataTable from "react-data-table-component";
import { Notyf } from "notyf";
import "notyf/notyf.min.css";
import ChecklistIcon from "@mui/icons-material/Checklist";
import NavbarSA from "../../../components/navbar-sa";
import server from "../../../variables";
import AddIcon from "@mui/icons-material/Add";
import ConsumerModal from "../../../components/Consumermodel";

const ConsumerDashboard = () => {
  const notyf = new Notyf();
  const navigate = useNavigate();
  const { id: schemeID } = useParams();

  const [consumers, setConsumers] = useState([]);
  const [consumerType, setConsumerType] = useState("All");
  const [search, setSearch] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [initialData, setInitialData] = useState(null);
  console.log('initialData',initialData)
  useEffect(() => {
    document.title = "Super Admin Dashboard | RBS";
    fetchConsumers();
  }, []);

  const fetchConsumers = async () => {
    try {
      const { data } = await Axios.get(
        `${server}admin/get-all-consumer/${schemeID}`,
        { headers: { authorization: localStorage.getItem("token") } }
      );

      if (data.status === 410) return navigate("/");
      if (data.status !== 200) throw new Error(data.message);

      setConsumers(data.consumer);
    } catch (err) {
      notyf.error("Failed to load consumers");
    }
  };

  const counts = useMemo(() => ({
    All: consumers.length,
    "Residential Consumer": consumers.filter(c => c.consumerType === "Residential Consumer").length,
    "Commercial Consumer": consumers.filter(c => c.consumerType === "Commercial Consumer").length,
    "Residential Cum Commercial Consumer": consumers.filter(c => c.consumerType === "Residential Cum Commercial Consumer").length,
  }), [consumers]);

  const filteredData = useMemo(() => {
    return consumers
      .filter(c => consumerType === "All" ? true : c.consumerType === consumerType)
      .filter(c => search
        ? `${c.consumerName || ""}${c.bussinessName || ""}`
            .toLowerCase()
            .includes(search.toLowerCase())
        : true
      );
  }, [consumers, consumerType, search]);

  const columns = useMemo(() => [
    { name: "Consumer ID", selector: r => r.consumerID, sortable: true },
    { name: "Name / Business", selector: r => r.consumerName || r.bussinessName || "—", sortable: true, wrap: true },
    { name: "Mobile", selector: r => r.mobileNumber, sortable: true },
    { name: "Meter", selector: r => r.meterNumber, sortable: true },
    {
      name: "Actions",
      center: true,
      cell: row => (
        <div className="d-flex gap-2">
          <button
            className="btn btn-outline-primary btn-sm"
            title="View"
            onClick={() => navigate(`/admin/scheme/${schemeID}/consumers/${row.consumerID}/view`)}
          >
            <i className="bi bi-eye-fill"></i>
          </button>

          <button
            className="btn btn-outline-warning btn-sm"
            title="Edit"
            onClick={() => {
              setInitialData(row);
              setShowModal(true);
            }}
          >
            <i className="bi bi-pencil-square"></i>
          </button>

          <button
            className="btn btn-outline-secondary btn-sm"
            title="Bill"
            onClick={() => navigate(`/admin/scheme/${schemeID}/consumers/${row.consumerID}/bill`)}
          >
            <i className="bi bi-receipt"></i>
          </button>
        </div>
      )
    },
  ], [navigate, schemeID]);

  return (
    <div className="page-wrapper bg-light min-vh-100">
      <NavbarSA />
      <div className="container p-3">

        <div className="row g-4 mb-3">
          {[
            { label: "Total Consumers", type: "All", count: counts.All },
            { label: "Residential", type: "Residential Consumer", count: counts["Residential Consumer"] },
            { label: "Commercial", type: "Commercial Consumer", count: counts["Commercial Consumer"] },
            { label: "Resi + Commercial", type: "Residential Cum Commercial Consumer", count: counts["Residential Cum Commercial Consumer"] },
          ].map(card => (
            <div key={card.type} className="col-12 col-sm-6 col-lg-3" onClick={() => setConsumerType(card.type)}>
              <div className={`card shadow-sm rounded-4 border-0 ${consumerType === card.type ? "border-primary border-3" : ""}`} style={{ cursor: "pointer", minHeight: "110px" }}>
                <div className="card-body d-flex justify-content-between align-items-center">
                  <div>
                    <div className="text-muted small">{card.label}</div>
                    <div className="fw-bold fs-4">{card.count}</div>
                  </div>
                  <ChecklistIcon className="text-primary" fontSize="large" />
                </div>
              </div>
            </div>
          ))}
        </div>

        {consumerType !== "All" && <h6 className="mb-3">Showing: <span className="text-primary">{consumerType}</span></h6>}

        <div className="card shadow-sm rounded-4 p-4 border-0">
          <div className="d-flex flex-column flex-md-row justify-content-between gap-3 mb-3">
            <div className="input-group shadow-sm search-input">
              <span className="input-group-text bg-white border-0">
                <i className="bi bi-search text-muted"></i>
              </span>
              <input
                type="text"
                className="form-control border-0"
                placeholder="Search by name, email or ID"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>

            <button
              className="btn btn-primary d-flex align-items-center gap-2"
              onClick={() => {
                setInitialData(null);
                setShowModal(true);
              }}
            >
              <AddIcon />
            </button>
          </div>

          <DataTable
            columns={columns}
            data={filteredData}
            pagination
            striped
            highlightOnHover
            responsive
            noDataComponent="No consumers found"
          />
        </div>
      </div>

  <ConsumerModal
  show={showModal}
  handleClose={() => {
    setShowModal(false); 
    fetchConsumers(); 
     setInitialData(null)
  }}
  fetchdata={fetchConsumers}
  schemeID={schemeID}
  navigate={navigate}
  initialData={initialData}
  consumerID={initialData ? initialData.consumerID : null} 
/>

    </div>
  );
};

export default ConsumerDashboard;
